'use client';

import { Bell } from 'lucide-react';
import Link from 'next/link';

import { useNotifications } from '../notifications-context';

export function NotificationsBell({ className = '' }: { className?: string }) {
  const { unread } = useNotifications();

  return (
    <Link
      href="/communications"
      aria-label={unread.total > 0 ? `Уведомления: ${unread.total} непрочитанных` : 'Уведомления'}
      title="Уведомления"
      className={`relative flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-[#25282E] transition-colors hover:bg-[#4a4f57] ${className}`}
    >
      <Bell className="h-4 w-4 text-[#6E7384]" />
      {unread.display && (
        <span className="absolute -right-1 -top-1 flex min-h-5 min-w-5 items-center justify-center rounded-full bg-[#FF3DAE] px-1 text-[10px] font-bold leading-none text-white">
          {unread.display}
        </span>
      )}
    </Link>
  );
}
